document.addEventListener('DOMContentLoaded', function() {
    console.log("JavaScript loaded and running");

    let collections = document.querySelectorAll('.navigation__item--with-children .navigation__link[href*="/collections/"]');
    console.log("Found collections: ", collections);

    collections.forEach(function(collection) {
        let collectionUrl = collection.getAttribute('href') + '.json';
        console.log("Checking collection:", collectionUrl);

        fetch(collectionUrl)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok ' + response.statusText);
                }
                return response.json();
            })
            .then(data => {
                console.log("Fetched data for:", collectionUrl, data);

                if (data.products && data.products.length === 0) {
                    console.log("No products found in collection:", collectionUrl);
                    collection.closest('.navigation__item').style.display = 'none';
                } else {
                    console.log("Products found in collection:", collectionUrl);
                }
            })
            .catch(error => console.error('Error fetching collection data:', error));
    });
});